module.exports = __webpack_public_path__ + "img/3.bdf9bba8.png";